(function () {
    'use strict';

    angular
        .module('createPairing')
        .config(config);

    function config($stateProvider) {
        $stateProvider
            .state('createPairing', {
                sticky: true,
                url: '/create-pairing/:mode?/:pid?',
                views: {
                    'createPairingView': {
                        templateUrl: 'create-pairing/views/create-pairing.tpl.html',
                        controller: 'CreatePairingCtrl',
                        controllerAs: 'createPairing'
                    }
                },
                onEnter: function (UserPrivilegesService) {
                    UserPrivilegesService.setUserPrivilegeView("create/patterns");
                }

            });
    }
}());
